import { IFortniteLeaderboardItem } from 'hooks/use-fortnite-leaderboard';
import React from 'react';
import { useFortniteLeaderboardContext } from './Context/Context';
import RankBadge from './RankBadge';

const TableBodyRow: React.FC<{ item: IFortniteLeaderboardItem; }> = ({ item }) => {
  const { isRanked, isPanel } = useFortniteLeaderboardContext();

  if (isRanked) {
    return (
      <tr>
        <td>{item.rank}</td>
        <td>
          <RankBadge rank="Gold_1" />
          {!isPanel && 'Gold 1'}
        </td>
        <td>
          {item.players.map(player => (
            <>
              <span key={player.displayName}>{player.displayName}</span>
              <br />
            </>
          ))}
        </td>
      </tr>
    );
  }

  return (
    <tr>
      <td>{item.rank}</td>
      <td>
        {item.players.map(player => (
          <>
            <span key={player.displayName}>{player.displayName}</span>
            <br/>
          </>
        ))}
      </td>
      <td>{item.points}</td>
      <td>{item.royals}</td>
      <td>{item.matches}</td>
      <td>{item.eliminations}</td>
    </tr>
  );
};

export default TableBodyRow;
